import React, { useState, useRef, useEffect } from 'react';

const OptionsBar = ({
  modes,
  activeMode,
  onModeChange,
  models,
  selectedModel,
  onModelChange,
  options,
  onOptionChange,
  refMode,
  onRefModeChange,
  onSubmit,
  submitting,
}) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [activeVendor, setActiveVendor] = useState(null);
  const dropdownRefs = useRef({});

  useEffect(() => {
    const handler = (e) => {
      if (openDropdown && dropdownRefs.current[openDropdown]) {
        if (!dropdownRefs.current[openDropdown].contains(e.target)) {
          setOpenDropdown(null);
        }
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [openDropdown]);

  const groupedModels = (models || []).reduce((groups, model) => {
    const vendor = model.vendor?.trim() || '其他厂商';
    if (!groups[vendor]) {
      groups[vendor] = [];
    }
    groups[vendor].push(model);
    return groups;
  }, {});

  const vendorList = Object.keys(groupedModels);
  const getInitialVendor = () => {
    const selectedVendor = selectedModel?.vendor?.trim() || '其他厂商';
    if (selectedModel && groupedModels[selectedVendor]) {
      return selectedVendor;
    }
    return vendorList[0] || null;
  };

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => {
      const next = prev === name ? null : name;
      if (next === 'model') {
        setActiveVendor(getInitialVendor());
      }
      return next;
    });
  };

  const currentModeName =
    modes?.find((m) => m.id === activeMode)?.name || '视频生成';
  const isSeedance25 = selectedModel?.id === 'Doubao-Seedance-2.5';
  const resolutionOptions = isSeedance25
    ? [
        { label: '自适应', value: '' },
        { label: '480P (864x480)', value: '864x480' },
        { label: '720P (1280x720)', value: '1280x720' },
        { label: '720P (720x1280)', value: '720x1280' },
        { label: '720P (960x960)', value: '960x960' },
        { label: '720P (1112x834)', value: '1112x834' },
        { label: '720P (834x1112)', value: '834x1112' },
        { label: '720P (1470x630)', value: '1470x630' },
      ]
    : [
        { label: '720P  (1280x720)', value: '1280x720' },
        { label: '720P  (720x1280)', value: '720x1280' },
        { label: '1080P (1920x1080)', value: '1920x1080' },
        { label: '1080P (1080x1920)', value: '1080x1920' },
        { label: '2K    (2560x1440)', value: '2560x1440' },
        { label: '2K    (1440x2560)', value: '1440x2560' },
        { label: '4K    (3840x2160)', value: '3840x2160' },
        { label: '4K    (2160x3840)', value: '2160x3840' },
        { label: '1:1   (1024x1024)', value: '1024x1024' },
        { label: '1:1   (720x720)', value: '720x720' },
      ];
  const durationOptions = isSeedance25
    ? [-1, 4, 5, 10, 15, 20, 30]
    : Array.from({ length: 15 }, (_, i) => i + 1);
  const selectedDuration = options.duration === undefined
    ? (isSeedance25 ? -1 : '5')
    : options.duration;

  return (
    <div className="creator-options-bar">
      <div
        className="creator-option-btn primary"
        ref={(el) => (dropdownRefs.current['mode'] = el)}
        onClick={() => toggleDropdown('mode')}
      >
        <span className="option-icon">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="12" r="10" opacity="0.2" />
            <path d="M10 8l6 4-6 4V8z" />
          </svg>
        </span>
        {currentModeName}
        <span className="option-arrow">&#9662;</span>
        {openDropdown === 'mode' && modes && (
          <div className="creator-dropdown">
            {modes.map((m) => (
              <div
                key={m.id}
                className={`creator-dropdown-item${activeMode === m.id ? ' selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onModeChange(m.id);
                  setOpenDropdown(null);
                }}
              >
                <span>{m.name}</span>
                {activeMode === m.id && (
                  <span className="creator-dropdown-check">&#10003;</span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <div
        className="creator-option-btn"
        ref={(el) => (dropdownRefs.current['model'] = el)}
        onClick={() => toggleDropdown('model')}
      >
        <span className="option-icon">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
        </span>
        {selectedModel?.name || '选择模型'}
        {openDropdown === 'model' && (
          <div className="creator-dropdown creator-model-dropdown">
            <div className="creator-model-vendor-list">
              {vendorList.map((vendor) => (
                <div
                  key={vendor}
                  className={`creator-dropdown-item creator-vendor-item${activeVendor === vendor ? ' selected' : ''}`}
                  onMouseEnter={() => {
                    if (activeVendor !== vendor) {
                      setActiveVendor(vendor);
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (activeVendor !== vendor) {
                      setActiveVendor(vendor);
                    }
                  }}
                >
                  <span>{vendor}</span>
                  <span className="creator-dropdown-arrow">&#8250;</span>
                </div>
              ))}
            </div>
            <div className="creator-model-list">
              {(groupedModels[activeVendor] || []).map((m) => (
                <div
                  key={m.id}
                  className={`creator-dropdown-item${selectedModel?.id === m.id ? ' selected' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onModelChange(m);
                    setOpenDropdown(null);
                  }}
                >
                  <span>{m.name}</span>
                  {selectedModel?.id === m.id && (
                    <span className="creator-dropdown-check">&#10003;</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {activeMode !== 'chat' && (
        <div
          className={`creator-option-btn${refMode === 'reference' ? ' primary' : ''}`}
          ref={(el) => (dropdownRefs.current['ref'] = el)}
          onClick={() => toggleDropdown('ref')}
        >
          <span className="option-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
          </span>
          {refMode === 'frame' ? '首尾帧参考' : '全能参考'}
          <span className="option-arrow">&#9662;</span>
          {openDropdown === 'ref' && (
            <div className="creator-dropdown">
              <div
                className={`creator-dropdown-item${refMode === 'frame' ? ' selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onRefModeChange('frame');
                  setOpenDropdown(null);
                }}
              >
                <span>首尾帧参考</span>
                {refMode === 'frame' && (
                  <span className="creator-dropdown-check">&#10003;</span>
                )}
              </div>
              <div
                className={`creator-dropdown-item${refMode === 'reference' ? ' selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onRefModeChange('reference');
                  setOpenDropdown(null);
                }}
              >
                <span>全能参考</span>
                {refMode === 'reference' && (
                  <span className="creator-dropdown-check">&#10003;</span>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {activeMode !== 'chat' && <div className="creator-option-divider" />}

      {activeMode !== 'chat' && (
        <div
          className="creator-option-btn"
          ref={(el) => (dropdownRefs.current['resolution'] = el)}
          onClick={() => toggleDropdown('resolution')}
        >
          <span className="option-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
          </span>
          {isSeedance25 && !options.size ? '自适应' : options.size || '1280x720'}
          {openDropdown === 'resolution' && (
            <div className="creator-dropdown">
              {resolutionOptions.map((opt) => (
                <div
                  key={opt.value}
                  className={`creator-dropdown-item${options.size === opt.value ? ' selected' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onOptionChange('size', opt.value);
                    setOpenDropdown(null);
                  }}
                >
                  <span>{opt.label}</span>
                  {options.size === opt.value && (
                    <span className="creator-dropdown-check">&#10003;</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {activeMode !== 'chat' && (
        <div
          className="creator-option-btn"
          ref={(el) => (dropdownRefs.current['duration'] = el)}
          onClick={() => toggleDropdown('duration')}
        >
          <span className="option-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </span>
          {selectedDuration === -1 ? '智能' : `${selectedDuration}s`}
          {openDropdown === 'duration' && (
            <div className="creator-dropdown">
              {durationOptions.map((n) => (
                <div
                  key={n}
                  className={`creator-dropdown-item${String(selectedDuration) === String(n) ? ' selected' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onOptionChange('duration', isSeedance25 ? n : String(n));
                    setOpenDropdown(null);
                  }}
                >
                  <span>{n === -1 ? '智能选择' : `${n}s`}</span>
                  {String(selectedDuration) === String(n) && (
                    <span className="creator-dropdown-check">&#10003;</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {isSeedance25 && activeMode !== 'chat' && (
        <div
          className="creator-option-btn"
          ref={(el) => (dropdownRefs.current['format'] = el)}
          onClick={() => toggleDropdown('format')}
        >
          {options['byPass.output_format'] || 'mp4'}
          {openDropdown === 'format' && (
            <div className="creator-dropdown">
              {['mp4', 'mov'].map((format) => (
                <div
                  key={format}
                  className={`creator-dropdown-item${(options['byPass.output_format'] || 'mp4') === format ? ' selected' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onOptionChange('byPass.output_format', format);
                    setOpenDropdown(null);
                  }}
                >
                  <span>{format.toUpperCase()}{format === 'mov' ? '（编辑/延长推荐）' : ''}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <button
        className="creator-submit-btn"
        onClick={onSubmit}
        disabled={submitting}
        title="提交生成"
      >
        {submitting ? (
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
          >
            <path d="M21 12a9 9 0 11-6.219-8.56" />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
              transform="rotate(-90 12 12)"
            />
          </svg>
        )}
      </button>
    </div>
  );
};

export default OptionsBar;
